import { createContext, useContext } from 'react';

/**
 * Which of the two independent inventory surfaces a component tree belongs to.
 *
 * The inventory management page renders its Map / Gun Barrel / Slot Table twice —
 * once for the always-mounted Main Page and once for the Unit Builder modal — each
 * backed by its OWN state (see `inventory-surface/atoms.ts` +
 * `inventory-surface/map-atoms.ts`). A single surface key threads through the
 * shared components so each instance reads/writes its own atoms without the two
 * leaking into each other.
 *
 * `'main'` is the default, so plain Type Curve pages (which never wrap a provider)
 * and every existing main-page consumer behave exactly as before.
 */
export type InventorySurface = 'main' | 'builder';

/** A per-surface pair of anything (atoms, values). */
export type SurfaceRecord<T> = Record<InventorySurface, T>;

export const SurfaceContext = createContext<InventorySurface>('main');

// The surface the calling component renders under. Defaults to 'main'.
export const useSurface = (): InventorySurface => useContext(SurfaceContext);
